import { SvgIcon } from "@mui/material";

export default function MapElementIcon(props) {
  return (
    <SvgIcon width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.3125 0.0625C5.40625 0 5.5 0 5.625 0.03125L12.4688 2L16.9688 0.1875C17.4375 0 18 0.34375 18 0.875V11.3438C18 11.6562 17.8125 11.9375 17.5 12.0312L12.6562 13.9688C12.5625 14.0312 12.4688 14.0312 12.3438 14L5.5 12.0312L1 13.8438C0.53125 14.0312 0 13.6875 0 13.1562V2.6875C0 2.375 0.15625 2.09375 0.46875 2L5.3125 0.0625ZM1 12.7812L5 11.1875V1.25L1 2.84375V12.7812ZM12 2.90625L6 1.1875V11.125L12 12.8438V2.90625ZM13 12.7812L17 11.1875V1.25L13 2.84375V12.7812Z"
        fill={props.htmlColor || "#757575"}
      />
    </SvgIcon>
  );
}
